

import { useLazyQuery, useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useNavigate } from 'react-router-dom';
import { Get_notifications_left } from '../../graphql/GraphqlQueries';
import { Delete_notification, Read_all_notification } from '../../graphql/GraphqlMutation';
import { useDispatch } from 'react-redux';
import { setCountersData } from '../../redux/message';
import { useSelector } from 'react-redux';
import PersonIcon from '../../media/images/icons/assets_light/outline-management-person-active.svg';
import RoomIcon from '../../media/images/icons/assets_light/outline-message-active.svg';
import ReplyIcon from '../../media/images/icons/assets_light/message-reply-thread.svg';
import TaskIcon from '../../media/images/icons/assets_light/outline-menu-task-active.svg';
import CallIcon from '../../media/images/icons/assets_light/outline-call-active.svg';
import { Tooltip } from 'react-tooltip';
import toast, { Toaster } from 'react-hot-toast';


const LeftNotificationOptions = ({ setMoreNotifyShow }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { countersdata } = useSelector((state) => state.message);
    // const getType = (type = 'default') => {
    //     // Convert to lowercase for case-insensitive comparison
    //     const typeLower = type?.toLowerCase();
    //     switch (typeLower) {
    //         case "task":
    //             return 'task_notify_icon';
    //         case "calendar":
    //             return 'calendar_notify_icon';
    //         case "file":
    //             return 'file_notify_icon';
    //         case "expense":
    //             return 'expense_notify_icon';
    //         default:
    //             return "default_icon";
    //     }
    // };

    const [getLeftNotifications] = useLazyQuery(Get_notifications_left, {
        fetchPolicy: "no-cache",
        onError: (error) => {
            console.error("Error fetching notifications:", error);
        }
    });
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        totalPages: 1,
        total: 1,
    });
    const [error, setError] = useState(null);

    const handleLeftNotification = async (page) => {
        try {
            setLoading(true);
            setError(null);
            const { data, error: queryError } = await getLeftNotifications({ variables: { page: page } });

            if (queryError) {
                setError(queryError.message);
                return;
            }

            console.log("🚀 ~ LeftSection ~ handleLeftNotification ~ data", data);
            setPagination(data?.get_notifications_left?.pagination)
            if (page > 1) {
                setNotifications((prev) => [...prev, ...(data?.get_notifications_left?.notification || [])]);
            } else {
                setNotifications(data?.get_notifications_left?.notification || []);
            }
        } catch (err) {
            setError(err.message);
            console.error("Error in handleLeftNotification:", err);
        } finally {
            setLoading(false);
        }
    }

    const [deleteNotificationMutation] = useMutation(Delete_notification)

    // // Delete single notification
    const deleteNotification = async (id) => {
        try {
            await deleteNotificationMutation({ variables: { input: { _id: id } } });
            toast.success("Notification deleted successfully");
            setNotifications((prev) => prev.filter((item) => item._id !== id));
            dispatch(setCountersData({ ...countersdata, notificationcount: countersdata?.notificationcount > 0 ? countersdata?.notificationcount - 1 : 0 }));

        } catch (error) {
            console.error("Error deleting notification:", error);
        }
    };

    const [clear_all_notifications] = useMutation(Read_all_notification)

    // Clear all notifications
    const clearAllNotifications = async () => {
        await clear_all_notifications();
        setNotifications([]);
        setPagination({
            page: 1,
            totalPages: 1,
            total: 1,
        });
        dispatch(setCountersData({ ...countersdata, notificationcount: 0 }));
    };

    useEffect(() => {
        handleLeftNotification(1);
    }, []);

    const loadMoreNotifications = () => {
        if (pagination.page < pagination.totalPages && !loading && !error) {
            handleLeftNotification(pagination.page + 1);
        }
    }

    useEffect(() => {
        console.log(116, pagination);
        console.log(117, pagination.page < pagination.totalPages);


    }, [pagination]);




    const getBodyData = (body) => {
        return JSON.parse(body);
    }

    const viewnotifi = (item) => {
        if (!item) return;

        const data = getBodyData(item.body);

        setMoreNotifyShow(false);
        switch (item.type) {
            case "conversation":
                if (item.conversation_id) {
                    navigate(`/connect/${item.conversation_id}`);
                }
                break;
            case "Message":
                if (data?.is_reply_msg === "yes") {
                    navigate(`/connect/${item.conversation_id}/reply/${data.reply_for_msgid}`);
                } else {
                    navigate(`/connect/${item?.conversation_id}/filter/${item?.msg_id}`);
                }
                break;
            case "Task":
                if (item.task_id) {
                    navigate(`/connect/tasks/kanban-view/${item.task_id}`);
                }
                break;
            case "File":
                if (item.conversation_id && item.msg_id) {
                    navigate(`/connect/${item?.conversation_id}/filter/${item?.msg_id}`);
                }
                break;
                
            default:
                break;
        }
    };



    return (
        <OutsideClickHandler onOutsideClick={() => setMoreNotifyShow(false)}>
            <Toaster position="top-center" reverseOrder={false} />
            <div className={`filterActionPopup !z-[9999]  !top-[120px] !w-[338px] `}>
                {/* <p className="profilenavMidleArea_label">Options</p> */}

                <div className="filterActionHeader flex justify-between items-center px-[20px] py-[8px]">
                    <span className="popup_header font-poppins text-[16px] font-semibold leading-[1.5] tracking-normal text-left text-text-body dark:text-text-light">Notifications</span>
                    {notifications.length !== 0 && <button
                        className="text-sm text-text-action hover:text-text-action-hover dark:!text-white cursor-pointer dark:!text-white"
                        onClick={clearAllNotifications}

                    >
                        Mark as read
                    </button>}
                    <span className="close_pinnen_popup cursor-pointer" onClick={() => setMoreNotifyShow(false)}></span>
                </div>

                {loading && (
                    <div className="text-center text-sm text-gray-500 py-4">
                        Loading notifications...
                    </div>
                )}

                {error && (
                    <div className="text-center text-sm text-red-500 py-4 px-4">
                        Error: {error}
                    </div>
                )}

                <ul className="filterActionList pb-[8px] max-h-[300px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 dark:!bg-surface-dark">
                    {notifications.length > 0 ? (
                        notifications.map((item) => (
                            <div
                                key={item._id}
                                className={"flex justify-between items-center !px-[20px]  py-2  border-b border-gray-100 last:border-b-0 cursor-pointer bg-white hover:bg-surface-light dark:!bg-surface-dark  dark:!text-white" + (item.read ? '' : ' bg-gray-50 dark:!bg-surface-dark')}
                            >
                                {/* Left Content with Icon */}
                                <div className="notificationContent w-[calc(100%-40px)]">

                                    <div className='flex items-center gap-2'>
                                        {/* <div className={`!w-[18px] !h-[18px] bg-[length:18px_18px] flex-shrink-0 notify_icon ${getType(item.type)}`} aria-hidden="true"></div> */}
                                        <div className='w-[18px] h-[100%] flex-shrink-0 flex items-center justify-center'>
                                            {item.type === "Mentioned" ? (
                                                <span className="userIcon userIconSingle ">
                                                    <span className='relative inline-block w-[24px] h-[24px] top-[0px] bg-[#303b4f] dark:bg-white pointer-events-none transition-colors'
                                                        style={{
                                                            WebkitMaskImage: `url(${PersonIcon})`,
                                                            WebkitMaskRepeat: "no-repeat",
                                                            WebkitMaskPosition: "center",
                                                            WebkitMaskSize: "contain",
                                                            maskImage: `url(${PersonIcon})`,
                                                            maskRepeat: "no-repeat",
                                                            maskPosition: "center",
                                                            maskSize: "contain",
                                                        }}
                                                    />
                                                </span>) :
                                                item.type === "conversation" ? (<span className="userIcon userIconRoom">
                                                    <span className='relative inline-block w-[24px] h-[24px] !top-[0px] bg-[#303b4f] dark:bg-white pointer-events-none transition-colors'
                                                        style={{
                                                            WebkitMaskImage: `url(${RoomIcon})`,
                                                            WebkitMaskRepeat: "no-repeat",
                                                            WebkitMaskPosition: "center",
                                                            WebkitMaskSize: "contain",
                                                            maskImage: `url(${RoomIcon})`,
                                                            maskRepeat: "no-repeat",
                                                            maskPosition: "center",
                                                            maskSize: "contain",
                                                        }}
                                                    />

                                                </span>) :
                                                    item.type === "Reply Message" ? (<span className="userIcon userIconReply">
                                                        <span className='relative inline-block w-[24px] h-[24px] !top-[0px] bg-[#303b4f] dark:bg-white pointer-events-none transition-colors'
                                                            style={{
                                                                WebkitMaskImage: `url(${ReplyIcon})`,
                                                                WebkitMaskRepeat: "no-repeat",
                                                                WebkitMaskPosition: "center",
                                                                WebkitMaskSize: "contain",
                                                                maskImage: `url(${ReplyIcon})`,
                                                                maskRepeat: "no-repeat",
                                                                maskPosition: "center",
                                                                maskSize: "contain",
                                                            }}
                                                        />
                                                    </span>) :
                                                        item.type === "Call" ? (<span className="userIcon userIconCall">
                                                            <span className='relative inline-block w-[20px] h-[20px] !top-[0px] bg-[#303b4f] dark:bg-white pointer-events-none transition-colors'
                                                                style={{
                                                                    WebkitMaskImage: `url(${CallIcon})`,
                                                                    WebkitMaskRepeat: "no-repeat",
                                                                    WebkitMaskPosition: "center",
                                                                    WebkitMaskSize: "contain",
                                                                    maskImage: `url(${CallIcon})`,
                                                                    maskRepeat: "no-repeat",
                                                                    maskPosition: "center",
                                                                    maskSize: "contain",
                                                                }}
                                                            />
                                                        </span>) :

                                                            item.type === "Task" ? (<span className="userIcon userIconTask">
                                                                <span className='relative inline-block w-[24px] h-[24px] top-[0px] bg-[#303b4f] dark:bg-white pointer-events-none transition-colors'
                                                                    style={{
                                                                        WebkitMaskImage: `url(${TaskIcon})`,
                                                                        WebkitMaskRepeat: "no-repeat",
                                                                        WebkitMaskPosition: "center",
                                                                        WebkitMaskSize: "contain",
                                                                        maskImage: `url(${TaskIcon})`,
                                                                        maskRepeat: "no-repeat",
                                                                        maskPosition: "center",
                                                                        maskSize: "contain",
                                                                    }}
                                                                />
                                                            </span>) :
                                                                (<span className="userIcon userIconTask">
                                                                    <span className='relative inline-block w-[24px] h-[24px] top-[0px] bg-[#303b4f] dark:bg-white pointer-events-none transition-colors'
                                                                        style={{
                                                                            WebkitMaskImage: `url(${RoomIcon})`,
                                                                            WebkitMaskRepeat: "no-repeat",
                                                                            WebkitMaskPosition: "center",
                                                                            WebkitMaskSize: "contain",
                                                                            maskImage: `url(${RoomIcon})`,
                                                                            maskRepeat: "no-repeat",
                                                                            maskPosition: "center",
                                                                            maskSize: "contain",
                                                                        }}
                                                                    />
                                                                </span>)}
                                        </div>
                                        <div className="text-xs text-disabled overflow-hidden break-words" onClick={() => viewnotifi(item)}>{item.title}</div>
                                    </div>
                                    {/* <div className="text-sm text-text-body">{item.message}</div> */}
                                </div>

                                {/* Delete Icon */}
                                <div
                                    id={"del" + item._id}
                                    className="delNotify_icon text-gray-400 hover:text-text-error cursor-pointer "
                                    onClick={(e) => {
                                        e.stopPropagation(); // prevent click event bubbling
                                        deleteNotification(item._id);
                                    }}
                                >

                                </div>
                                <Tooltip className="!z-50" anchorSelect={"#del" + item._id} place='left' content="Delete" />
                            </div>
                        ))
                    ) : !loading && !error ? (
                        <div className="text-center text-sm text-gray-500 py-4">
                            No notification(s)
                        </div>
                    ) : null}
                    {pagination.page < pagination.totalPages && <div className='flex align-items-center text-sm text-text-action hover:text-text-action-hover dark:!text-white justify-center py-2 cursor-pointer dark:!text-white' onClick={loadMoreNotifications}>Load more</div>}
                </ul>
            </div>
        </OutsideClickHandler>
    );
};

export default LeftNotificationOptions;